import { render, staticRenderFns } from "./ClipboardModal.vue?vue&type=template&id=558e8874&"
import script from "./ClipboardModal.vue?vue&type=script&lang=js&"
export * from "./ClipboardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports